import { ROOT_ADMIN_USERNAME, UserRole } from '@ferty9/constants';
import { Permission } from './permissions.js';

export interface AuthUser {
  id?: string;
  username: string;
  center_name: string;
  is_superadmin?: boolean | null;
  role?: UserRole | string | null;
  permissions?: readonly Permission[] | readonly string[] | null;
  roles?: readonly string[] | null;
  centerAccess?: readonly string[] | null;
  isRootAdmin?: boolean | null;
}

export function isAdminUser(user: Pick<AuthUser, 'is_superadmin' | 'role'> | null | undefined): boolean {
  const authUser = user as AuthUser | null | undefined;
  return Boolean(
    authUser?.is_superadmin ||
      authUser?.isRootAdmin ||
      authUser?.permissions?.includes('user_accounts.update') ||
      authUser?.permissions?.includes('role_management.manage') ||
      authUser?.role === 'ADMIN',
  );
}

export function canHoldAdminRole(username: string): boolean {
  return username === ROOT_ADMIN_USERNAME;
}
